// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, CheckIncludeAttributeTypesParameter } from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";

interface Parameter {
    id: string;
    productIds: string[];
    includeAttributeTypes?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetProductCollectionApiV2Parameter>;

export const XCheckIncludeAttributeTypesParameter: HandlerType = props => {
    if (props.parameter.includeAttributeTypes) {
        props.apiParameter.expand?.push("attributes");
        props.apiParameter.expand?.push("variantTraits");
        props.apiParameter.includeAttributes = ["includeOnProduct"];
    }
};

replaceInChain(chain, CheckIncludeAttributeTypesParameter, XCheckIncludeAttributeTypesParameter);
